import { randmarApiWithTags } from "randmar-api-client";

type GetV4ManufacturerDocumentPdfBlobArgs = {
  routeManufacturerId: string;
  documentNumber: string;
};

type MinimalEndpointBuilder = {
  query<Result, Arg>(definition: {
    query: (arg: Arg) => {
      url: string;
      responseHandler?: (response: Response) => Promise<Result>;
    };
  }): unknown;
};

export const randmarApiExtended = randmarApiWithTags.injectEndpoints({
  endpoints: (build: MinimalEndpointBuilder) => ({
    getV4ManufacturerDocumentPdfBlob: build.query<
      Blob,
      GetV4ManufacturerDocumentPdfBlobArgs
    >({
      query: ({ routeManufacturerId, documentNumber }) => ({
        url: `/V4/Manufacturer/${routeManufacturerId}/Document/${documentNumber}/PDF`,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetV4ManufacturerDocumentPdfBlobQuery,
  useLazyGetV4ManufacturerDocumentPdfBlobQuery,
} = randmarApiExtended;
